import ApiService from '@/api';
import {
  GetProjectTasksRequestModel,
  GetUserRequest,
  GetUserResponce,
  OrderTaskModel,
  TaskModel,
} from '../models';
import { PaginationResponseModel, ResponseModel, UserModel } from '@/models';
import {
  mapGetTasksByProjectIdRequest,
  mapGetTasksByProjectIdResponse,
} from './MonitoringsAdapterServiceMappers';
import GetEmployeesWithAccessToProjectResponseModel from '../models/GetEmployeesWithAccessToProjectResponseModel';
import GetEmployeesWithAccessToProjectRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetEmployeesWithAccessToProjectRequest';
import PerformerTaskDaysRequestModel from '../models/PerformerTaskDaysRequestModel';
import PerformerTaskDaysResponseModel from '../models/PerformerTaskDaysResponseModel';
import {
  mapGetEmployeeRequest,
  mapGetEmployeeResponse,
} from '@/pages/employee-tasks-page/adapter/AdapterServiceMappers';

export default class MonitoringTicketsAdapterService {
  /**Сервис для использования api */
  private readonly api = new ApiService();

  /**
   * Получить список задач по проекту
   * @param request Запрос
   * @returns
   */
  getTasksByProjectId(
    request: GetProjectTasksRequestModel,
  ): Promise<PaginationResponseModel<TaskModel[]>> {
    return new Promise<PaginationResponseModel<TaskModel[]>>(async (resolve) => {
      let result = new PaginationResponseModel<TaskModel[]>();

      await this.api.Main.ProjectTaskGetService.getTaskListByTreeShortAsync(
        mapGetTasksByProjectIdRequest(request),
      )
        .then((resp) => {
          result = mapGetTasksByProjectIdResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTasksByProjectId', e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получение списка сотрудников с доступом к проекту
   */
  getEmployeesWithAccessToProject(
    request: GetEmployeesWithAccessToProjectRequest,
  ): Promise<ResponseModel<GetEmployeesWithAccessToProjectResponseModel>> {
    return new Promise<ResponseModel<GetEmployeesWithAccessToProjectResponseModel>>(
      async (resolve) => {
        let result = new ResponseModel<GetEmployeesWithAccessToProjectResponseModel>();

        await this.api.Main.PerformersListService.getEmployeesWithAccessToProjectAsync(request)
          .then((resp) => {
            result.Value = resp;
            return resolve(result);
          })
          .catch((e) => {
            result.IsSuccess = false;
            result.ErrorCode = e?.ErrorCode;
            result.ErrorMessage = e?.ErrorMessage;
            console.error('ERROR getTasksByProjectId', e);
            return resolve(result);
          });
      },
    );
  }
  /**
   * Получить информацию о сотруднике
   * @param employeeId ID сотрудника
   * @returns
   */
  getEmployee(employeeId: number) {
    return new Promise<ResponseModel<UserModel>>(async (resolve) => {
      const result = new ResponseModel<UserModel>();

      await this.api.Main.PerformersListService.getByIdAsync(mapGetEmployeeRequest(employeeId))
        .then((resp) => {
          result.Value = mapGetEmployeeResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getEmployee', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение списка сотрудников и их затраченное время на задачи по дням
   */
  async getPerformerTaskDaysReportAsync(
    request: PerformerTaskDaysRequestModel,
  ): Promise<ResponseModel<PerformerTaskDaysResponseModel>> {
    return new Promise<ResponseModel<PerformerTaskDaysResponseModel>>(async (resolve) => {
      let result = new ResponseModel<PerformerTaskDaysResponseModel>();

      await this.api.Main.EmployeeService.getPerformerTaskDaysReportAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTasksByProjectId', e);
          return resolve(result);
        });
    });
  }
}
